import '@/observability/sentry'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { WagmiProvider } from 'wagmi'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { wagmiConfig } from './config/wagmi-config'
import { BrowserRouter as Router } from 'react-router-dom'
import { Avatar } from '@/components/ui/Avatar'
import App from './App'
import './index.css'
import { setupGTM, sendEvent as sendEventGTM } from './lib/gtm'
import { TrackingProvider } from './providers/TrackingProvider'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: true,
			retry: 6
		}
	}
})

const VITE_GTM_ID = import.meta.env.VITE_GTM_ID
if (VITE_GTM_ID) setupGTM(VITE_GTM_ID)

const gtmTrackingService = {
	sendEvent: sendEventGTM
}

const trackingServices = [gtmTrackingService]

const rootElement = document.getElementById('root')
if (rootElement) {
	createRoot(rootElement).render(
		<React.StrictMode>
			<TrackingProvider services={trackingServices}>
				<WagmiProvider config={wagmiConfig}>
					<QueryClientProvider client={queryClient}>
						<RainbowKitProvider avatar={Avatar}>
							<Router>
								<App />
							</Router>
						</RainbowKitProvider>
					</QueryClientProvider>
				</WagmiProvider>
			</TrackingProvider>
		</React.StrictMode>
	)
}
